import Partner from "../../../classes/Partner";
import * as React from "react";
import AppContext from "../AppContext";
import Section from "../Section/Section";
import api from "../../api";
import PurchaseOrder from "../../../classes/PurchaseOrder";

type SectionPurchaseOrdersProps = {
  partner: Partner;
  canCreatePartner: boolean;
};

type SectionPurchaseOrdersState = {
  purchaseOrders: PurchaseOrder[];
};

class SectionPurchaseOrders extends React.Component<SectionPurchaseOrdersProps, SectionPurchaseOrdersState> {
  constructor(props, context) {
    super(props, context);
    this.state = { purchaseOrders: this.props.partner.purchaseOrders };
  }

  private getPurchaseOrderDescription = (purchaseOrder: PurchaseOrder): string => {
    const currency = Array.isArray(purchaseOrder.currency_id) ? purchaseOrder.currency_id[1] : "";
    return [purchaseOrder.amount_total, currency].filter(value => value !== "" && value !== undefined).join(" ");
  };

  render() {
    return (
      <Section
        records={this.state.purchaseOrders}
        partner={this.props.partner}
        canCreatePartner={this.props.canCreatePartner}
        model="purchase.order"
        odooEndpointCreateRecord={api.createPurchaseOrder}
        odooRecordIdName="purchaseOrder_id"
        odooRedirectAction="purchase.purchase_rfq"
        title="Purchase Orders"
        titleCount="Purchase Orders (%(count)s)"
        msgNoPartner="Save Contact to create new Purchase Orders."
        msgNoPartnerNoAccess="The Contact needs to exist to create Purchase Orders."
        msgNoRecord="No purchase orders found for this contact."
        msgLogEmail="Log Email Into Purchase Order"
        getRecordDescription={this.getPurchaseOrderDescription}
      />
    );
  }
}

SectionPurchaseOrders.contextType = AppContext;
export default SectionPurchaseOrders;
